export default {
    LoginWrp:{
        width:'100%',
        height:'47.3px',
        display:'flex',
        flexDirection:'row',
        backgroundColor: "rgba(46, 49, 146, 0.2)",
        boxShadow:'0 4px 4px 0 rgba(0, 0, 0, 0.24), 0 0 4px 0 rgba(0, 0, 0, 0.12)',
    },
    HeaderWrp:{
        width:'100%',
        display:'flex',
        flexDirection:'row',
        justifyContent: 'space-between',
    },
    HeaderRightWrp:{
        display:'flex',
        justifyContent:'flex-start',
        alignItems:'center'
    },
    LoginRight:{
        height: "24px",
        fontFamily: "Roboto, Arial, Helvetica, sans-serif",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "1.5",
        letterSpacing: "0.15px",
        color: "#000",
        fontSize: "1em",
        display:'flex',
        marginLeft: '24px'
    },
    HeaderLeftWrp:{
        display:'flex',
        justifyContent:'flex-end',
        alignItems:'center'
    },
    LoginLeft:{
        width: "80px",
        height: "24px",
        fontFamily: "Roboto, Arial, Helvetica, sans-serif",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "1.5",
        letterSpacing: "0.15px",
        color: "#000",
        fontSize: "16px",
        display:'flex',
        cursor:'pointer'
    },
    goToDashboardBtn : {
        color: "#ffffff",
        fontFamily: "Roboto, Arial, Helvetica, sans-serif",
        backgroundColor: "#1a2c40",
        boxShadow: "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)",
        textTransform: "uppercase",
        padding: "6px 16px",
        fontSize: "0.875rem",
        cursor: "pointer",
        fontWeight: "500",
        lineHeight: "1.75",
        borderRadius: "4px",
        letterSpacing: "0.02857em",
        width: 'max-content',
        marginRight: 12
    },
    HeaderRightLogo:{
        // width: "150px",
        height: "50px",
        margin: '11px'
    },
    HeaderLeftLogo:{
        width: "75px",
        height: "50px",
        marginRight:'8px'
    },
    HeaderLeftText:{
        height: "50px",
        fontFamily: "Roboto, Arial, Helvetica, sans-serif",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "2.86",
        letterSpacing: "0.15px",
        color: "#4f4f4f",
        fontSize: "14px",
        display:'flex',
        justifyContent:'center',
        alignItems:'center'
    },
    doneBtn : {
        root: {
            width: '210px',
            height: '40px',
            marginTop: '53px',
            paddingTop: '9px',
            backgroundColor: '#1a2c40',
            color: '#ffffff',
            '&:hover': {
                backgroundColor: '#1a2c40',
                boxShadow: '0 4px 8px 0 rgba(46, 49, 146, 0.2), 0 2px 4px 0 rgba(46, 49, 146, 0.2)',
            },
            '&:focus':{
                outline:'none'
            },
            '&:disabled': {
                backgroundColor: '#e1e1e3',
                color: '#ffffff'
            },
        },
    },
    crudBtn : {
        root: {
            backgroundColor: '#ee1c21',
            color: '#ffffff',
            fontFamily : 'Roboto, Arial, Helvetica, sans-serif',
            '&:hover': {
                backgroundColor: '#1a2c40',
                boxShadow: '0 4px 8px 0 rgba(46, 49, 146, 0.2), 0 2px 4px 0 rgba(46, 49, 146, 0.2)',
            },
            '&:focus':{
                outline:'none'
            },
            '&:disabled': {
                backgroundColor: '#e1e1e3',
                color: '#ffffff'
            },
        },
    },
    viewBtn : {
        root: {
            backgroundColor: '#1a2c40',
            color: '#ffffff',
            display: 'inline-flex',
            alignItems: 'center',
            fontFamily : 'Roboto, Arial, Helvetica, sans-serif',
            '&:hover': {
                backgroundColor: '#1a2c40',
                color: '#ffffff',
                boxShadow: '0 4px 8px 0 rgba(46, 49, 146, 0.2), 0 2px 4px 0 rgba(46, 49, 146, 0.2)'
            },
            '&:disabled': {
                backgroundColor: '#e1e1e3',
                color: '#ffffff'
            },
            '&:focus':{
                outline:'none'
            },
        },
    },
    QuickQt1TopWrp:{
        // padding:'25px',
        display:'flex',
        flexDirection:'column',
        marginLeft:'1%',
        paddingBottom:'25px',
        paddingTop:'25px',
        marginRight : '4%'
    },
    QuickQtTopRightText1:{
        width: "302px",
        // height: "40px",
        fontFamily: "Roboto, Arial, Helvetica, sans-serif",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "1.67",
        letterSpacing: "0.15px",
        color: "#3399cd",
        fontSize: "24px",
        textAlign:'justify'
    },
    QuickQtTopRightText2:{
        fontFamily: "Roboto, Arial, Helvetica, sans-serif",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "1.5",
        letterSpacing: "normal",
        color: "#ee1c21",
        fontSize: "15px",
        wordSpacing: '1px',
        textAlign:'justify',
       // paddingRight:'19px'
    },
    QuickQtZipTitleCoverage:{
        fontFamily: "Roboto, Arial, Helvetica, sans-serif",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "1.14",
        letterSpacing: "normal",
        color: "rgba(0, 0, 0, 0.87)",
        fontSize: "14px",
        marginBottom:'10px',
        // marginLeft:'23.5%'
    },
    QuickQtZipTitle:{
        fontFamily: "Roboto, Arial, Helvetica, sans-serif",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "1.14",
        letterSpacing: "normal",
        color: "rgba(0, 0, 0, 0.87)",
        fontSize: "14px",
        // marginBottom:'10px',
        // marginLeft:'3%'
    },
    FooterChildWrp1:{
        display:'flex',
        width:'100%',
        marginBottom:'1%'
    },
    FooterChildWrp2:{
        display:'flex',
        width:'100%',
    },
    QuickQt2TopWrp:{
        // padding:'25px',
        display:'flex',
        flexDirection:'column',
        marginLeft:'1%',
        paddingBottom:'25px',
        paddingTop:'25px',
        paddingRight:'17px'

    },
    QuickQtTopRightText1:{
        width: "302px",
        // height: "40px",
        fontFamily: "Roboto, Arial, Helvetica, sans-serif",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "1.67",
        letterSpacing: "0.15px",
        color: "#eb1f25",
        fontSize: "24px",
        textAlign:'justify'
    },
    QuickQtTopRightText2:{
        fontFamily: "Roboto, Arial, Helvetica, sans-serif",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "1.5",
        letterSpacing: "normal",
        color: "rgba(0, 0, 0, 0.87)",
        fontSize: "15px",
        wordSpacing: '1px',
        textAlign:'justify',
       // paddingRight:'19px'
    },
    lastRow : {
        backgroundColor : 'rgba(46, 49, 146, 0.4)',
        borderBottom : '2px solid rgba(46, 49, 146, 0.4)',
        color:'#FFFFFF',
        body:{
            color:'#ffffff'
        }
    },
    tableCell : {  //for Table Cell
        root: {
            padding: '10px',
            width:'auto',
            fontFamily : 'Roboto, Arial, Helvetica, sans-serif'
        },
        
        head: {
            backgroundColor: '#e7e9f2',
            color: '#ffffff',
            fontSize: '14px',
            // fontSize:'16px',
            fontWeight:'bold',
            lineHeight: '22px',
            width:'20px'
        },
        body: {
            fontSize: '16px',
            lineHeight: '24px',
            // color: '#f30',
            fontWeight : 'bold',
            color:'#000 !important',
        
        },
    },
  
    tableCell1 : {  //for Table Cell
        root: {
            padding: '10px',
            width:'300px',
            fontFamily : 'Roboto, Arial, Helvetica, sans-serif'
        },
        
        head: {
            backgroundColor: '#1a2c40',
            color: '#ffffff',
            fontSize: '14px',
            // fontSize:'16px',
            fontWeight:'bold',
            lineHeight: '22px',
            width:'20px'
        },
        body: {
            fontSize: '16px',
            lineHeight: '24px',
            // color: '#f30',
            fontWeight : 'bold',    
            color:'#000 !important',
        },
    },
    tableRow : { //for Table Row
        root: {
            backgroundColor: 'rgba(46, 49, 146, 0.2)',
            height: '38px',
            padding: '10px',
            color:'#ffffff',
            fontFamily : 'Roboto, Arial, Helvetica, sans-serif'
        },
    },
    CommonChatBtn:{
        width: '56px',
        height: '56px',
        backgroundColor : "#1a2c40",
        color: '#ffffff',
        borderRadius: '50%',
        border: "none",
    },
    QuickQtRemoveTxt:{
        width: '20px',
        display:'flex',
        fontFamily: "Roboto, Arial, Helvetica, sans-serif",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "1.14",
        letterSpacing: "normal",
        color: "rgba(0, 0, 0, 0.87)",
        fontSize: "14px",
        marginTop:'-43px',
        marginLeft:'64px'
    },
    QuickAddBtn:{
        width: '56px',
        height: '56px',
        marginTop:'39px',
        marginLeft:'-17%'
    },
    QuickRemoveBtn:{
        width: '56px',
        height: '56px',
        // marginTop:'39px',
        // marginLeft:'-17%'
    },
    QuickAddBtn1:{
        width: '56px',
        height: '56px',
        marginTop:'23px',
        marginLeft:'-3.9%'
    },
    QuickQtDepedentTxt22:{
        width: '20px',
        fontFamily: "Roboto, Arial, Helvetica, sans-serif",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "1.14",
        letterSpacing: "normal",
        color: "rgba(0, 0, 0, 0.87)",
        fontSize: "14px",
        marginTop:'63px',
        marginLeft:'10px',
    },
    QuickQtSpouseTitle:{
        fontFamily: "Roboto, Arial, Helvetica, sans-serif",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "1.14",
        letterSpacing: "normal",
        color: "rgba(0, 0, 0, 0.87)",
        fontSize: "14px",
        // marginBottom:'10px',
        // marginLeft:'53%'
    },
    QuickQtDtlsWrp:{
        width:'106%',
        display:'flex',
        flexDirection:'row',
    },
}




